// extracted by mini-css-extract-plugin
export default {"tokenForm__accordion":"TokenForm_tokenForm__accordion__l-S4y"};